import { render, staticRenderFns } from "./PublicSocialLoginGoogleMyBusiness.vue?vue&type=template&id=7161953e"
import script from "./PublicSocialLoginGoogleMyBusiness.vue?vue&type=script&lang=ts"
export * from "./PublicSocialLoginGoogleMyBusiness.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports